import { Controller } from "@hotwired/stimulus"
import { Avatar } from "@dicebear/core"
import { AVATAR_STYLE, AVATAR_OPTIONS } from "../../lib/avatar_options"

export default class extends Controller {
  static targets = ["avatar", "nickname", "avatarInput", "nicknameInput"]
  static values = { adjectives: Array, animals: Array }

  connect() {
    this.roll()
  }

  roll() {
    const adjective = this.adjectivesValue[Math.floor(Math.random() * this.adjectivesValue.length)]
    const animal = this.animalsValue[Math.floor(Math.random() * this.animalsValue.length)]
    const nickname = `${adjective} ${animal}`
    const seed = Array.from(crypto.getRandomValues(new Uint8Array(8)))
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("")
    this.avatarTarget.innerHTML = new Avatar(AVATAR_STYLE, { ...AVATAR_OPTIONS, seed, size: 56 }).toString()
    this.nicknameTarget.textContent = nickname
    this.avatarInputTarget.value = seed
    this.nicknameInputTarget.value = nickname
  }
}
